import { render, staticRenderFns } from "./SearchOrderLiveClassPacege.vue?vue&type=template&id=e7fd3eae&"
import script from "./SearchOrderLiveClassPacege.vue?vue&type=script&lang=js&"
export * from "./SearchOrderLiveClassPacege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
